export const dataFrases = [
  {
    id: 1,
    frases: [
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 2,
    frases: [
      'Quem mais estava envolvido?',
      'O que você determinou que fizessem?',
      'Como você conseguiu que fizessem isso?',
      'O que você disse a ele(s)?',
      'Quais resultados obteve com o que determinou que fizessem?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'Falou com alguém sobre o que estava por fazer?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 3,
    frases: [
      'Qual a dificuldade da situação?',
      'Encontrou alternativa para tratar o problema?',
      'O que pensava durante esta situação?',
      'Que êxito considera ter alcançado por superar este problema?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 4,
    frases: [
      ' O que mais lhe orgulhou por ter conseguido isto?',
      'Houve outra coisa importante que você fez nesta situação?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      ' O que considera que alcançou?',
    ],
  },
  {
    id: 5,
    frases: [
      'Qual era o risco?',
      'O que pensava deste risco naquele momento?',
      'Voltaria a correr o risco?',
      'O que o levou a tomar esta decisão?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
];
